var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TodoList',{attrs:{"todos":_vm.myTodos,"is-loading":_vm.isLoadingMyTodoData,"is-last-page":!_vm.hasMoreMyTodos},on:{"loadMoreTodos":_vm.loadMoreTodos}})}
var staticRenderFns = []

export { render, staticRenderFns }